import useWalletSetAsideToast from 'components/pages/Banks/Wallet/useWalletSetAsideToast';
import { type FC, type PropsWithChildren } from 'react';
import { WalletNudgesContext } from './context';

const WalletNudgesProvider: FC<PropsWithChildren<any>> = ({ children }) => {
  const { walletSetAsideToastContent, showWalletSetAsideToast } =
    useWalletSetAsideToast();

  return (
    <WalletNudgesContext.Provider value={{ showWalletSetAsideToast }}>
      {walletSetAsideToastContent}

      {children}
    </WalletNudgesContext.Provider>
  );
};

export default WalletNudgesProvider;
